import { createTheme } from "@mui/material";
export const theme = createTheme({
  typography: {
    fontFamily: "Spartan, sans-serif", // Use the desired font family (Spartan in this case)
  },
});
